import Navigation from '../components/navigation/index';
import React from 'react';
import FooterSection from '../components/footer/index';
import { Facebook, GitHub, LinkedIn } from '@material-ui/icons';

export default function FooterContainer () {
    return <FooterSection>
        <FooterSection.Text>
            &copy; Copyright 2021 MuzamilHussain.com
        </FooterSection.Text>
        <Navigation right footer>
                <Navigation.Item href="https://github.com/Muzamil-Hussain" target = "_blank">
                    <GitHub style={{fontSize: 40}} />
                </Navigation.Item>
                <Navigation.Item href="https://www.linkedin.com/in/muzamil-hussain-830643150/" target = "_blank">
                    <LinkedIn style={{fontSize: 40}} />
                </Navigation.Item>
                <Navigation.Item href="https://www.facebook.com/muzamilsethar/" target = "_blank">
                    <Facebook style={{fontSize: 40}} />
                </Navigation.Item>
        </Navigation>
    </FooterSection>
}